var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { lincdServer } from '../../ontologies/lincd-server.js';
import { linkedShape } from '../../package.js';
import { BackendStore } from './BackendStore.js';
import { QuadArray } from 'lincd/collections/QuadArray';
import { Server } from 'lincd-server-utils/utils/Server';
/**
 * Passes all request to the BackendAPIStoreProvider which runs on the LINCD Server backend.
 * The backend Storage in turn will likely be configured to connect to other graph stores
 * @see BackendAPIStoreProvider
 */
let BackendAPIStore = class BackendAPIStore extends BackendStore {
    constructor(n) {
        if (typeof n === 'string') {
            super();
            this.label = n;
        }
        else {
            super(n);
        }
    }
    selectQuery(query) {
        //TODO: replace with API call
        return Server.call(this, 'selectQuery', query);
    }
    updateQuery(query) {
        //TODO: replace with API call
        return Server.call(this, 'updateQuery', query);
    }
    createQuery(query) {
        //TODO: replace with API call
        return Server.call(this, 'createQuery', query);
    }
    deleteQuery(query) {
        //TODO: replace with API call
        return Server.call(this, 'deleteQuery', query);
    }
    loadShape(shapeInstance, request) {
        return Server.call(this, 'loadShape', shapeInstance, request).then((quads) => {
            if (quads instanceof QuadArray) {
                this._addToContents(quads);
            }
            else {
                console.log('BackendAPIStore.loadShape: quads is not a QuadArray: ', quads);
            }
            return quads;
        });
    }
    loadShapes(shapeInstances, request) {
        return Server.call(this, 'loadShapes', shapeInstances, request).then((quads) => {
            if (quads instanceof QuadArray) {
                this._addToContents(quads);
            }
            else {
                console.log('BackendAPIStore.loadShapes: quads is not a QuadArray: ', quads);
            }
            return quads;
        });
    }
};
BackendAPIStore.targetClass = lincdServer.BackendAPIStore;
BackendAPIStore = __decorate([
    linkedShape,
    __metadata("design:paramtypes", [Object])
], BackendAPIStore);
export { BackendAPIStore };
//# sourceMappingURL=BackendAPIStore.js.map